import styled from "styled-components"
import { theme } from "Theme"

export const Grid = styled.div`
  margin: 2rem auto;
  display: inline-grid;
  align-items: center;

  grid-template-columns: 160px 160px;
  @media (min-width: ${theme.breakpoints.s}) {
    grid-template-columns: 180px 180px;
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: 180px 180px 180px 180px;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: 160px 160px 160px 160px;
  }
  grid-gap: 2rem;
`

export const Title = styled.h2`
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  overflow: hidden;
  color: inherit;
`

export const Subtitle = styled.p`
  color: inherit;
  font-weight: normal;
  max-width: ${theme.layout.blog};
  margin: 0 auto;
  & + a {
    margin-top: 1rem;
  }
  text-align: center;
`

export const Card = styled.div`
  height: 100%;
  // background: #fff;
  // border-radius: ${theme.borderRadius.elements};
  // box-shadow: ${theme.shadow.feature.small.default};
  // border: 1px solid #ddd;
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: ${theme.breakpoints.s}) {
    align-items: center;
  }
`

export const Logo = styled.div`
  cursor: pointer;
  display: flex;
  position: relative;
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.medium};
  font-weight: bold;
  // padding: 4px 1rem;
  justify-content: center;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  img {
    margin: 0;
  }
  .gatsby-image-wrapper {
    width: 260px;
    height: 130px;
    @media (min-width: ${theme.breakpoints.m}) {
      width: 200px;
      height: 120px;
    }
  }
  picture {
    img {
      margin: 0;
      // filter: grayscale(1);
      opacity: 0.7 !important;
      &:hover {
        filter: none;
        opacity: 1 !important;
      }
    }
  }
`
